import { useCallback } from 'react';
import produce from 'immer';
import type { CoreInstanceType } from 'common/core/CoreInstanceConstants';
import { DeploymentClientState, useDeploymentClientState } from 'client/state/DeploymentClientState';
import { VMSelect } from './VMSelect';

export const SettingsVM = () => {
  const coreInstanceTypeID = useDeploymentClientState((state) => state.document?.coreInstanceTypeID || null);
  const isDevelopment = useDeploymentClientState((state) => state.document?.stage === 'development');

  const handleChange = useCallback((coreInstanceTypeID: CoreInstanceType) => {
    useDeploymentClientState.setState(
      produce((state: DeploymentClientState) => {
        state.document!.coreInstanceTypeID = coreInstanceTypeID;
      })
    );
  }, []);

  return (
    <>
      <VMSelect value={coreInstanceTypeID} showDevWarning={isDevelopment} onChange={handleChange} />
    </>
  );
};
